import { render, staticRenderFns } from "./SavingsCTA.vue?vue&type=template&id=625fd6ac"
import script from "./SavingsCTA.vue?vue&type=script&lang=js"
export * from "./SavingsCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports